import React from 'react';
import { MenuItem, Avatar } from '@material-ui/core';
import LevelManager from '../../../levels';
import FlatWorld from "../../../world";

interface SpriteListProps {
    selectSpriteElement: (sprite: any) => void;
    activeSpriteId: string | undefined;
}

const avatarBg1 = (fillColor: string, strokeColor: string) => {
    return `<svg width="140" height="132" viewBox="0 0 140 132" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M56.3689 124.271C5.27609 119.041 9.61989 105.582 14.1547 52.6661C16.3241 27.3514 40.0682 22.2875 75.26 15.7703C132.718 5.1296 130.962 20.0142 127.068 97.5491C125.786 123.096 89.0958 127.621 56.3689 124.271Z" fill="${fillColor}"/>
  <path d="M57.9466 117.294C12.7956 112.694 16.6355 100.832 20.6479 54.1995C22.5675 31.8906 43.5509 27.4241 74.6511 21.6749C125.429 12.2881 123.875 25.4054 120.427 93.7334C119.291 116.247 86.8674 120.241 57.9466 117.294Z" stroke="${strokeColor}" stroke-width="2.8764" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="7.19 7.19"/>
  </svg>
  `
}

const avatarBg2 = (fillColor: string, strokeColor: string) => {
    return `<svg width="118" height="103" viewBox="0 0 118 103" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.42074 33.2146C22.5271 -4.26903 34.7435 0.967248 84.7581 12.1624C108.685 17.5181 109.779 36.0423 110.454 63.3519C111.555 107.941 97.563 104.432 23.8429 90.0878C-0.446761 85.3617 1.02565 57.2242 9.42074 33.2146Z" fill="${fillColor}"/>
    <path d="M15.2554 35.352C26.8263 2.22554 37.6049 6.85081 81.7346 16.7356C102.846 21.4645 103.809 37.8342 104.4 61.9676C105.364 101.371 93.018 98.2719 27.9718 85.6085C6.54002 81.4361 7.84388 56.5707 15.2554 35.352Z" stroke="${strokeColor}" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="10 10"/>
    </svg>
    `
}

const avatarBackgrounds = (fillColor: string, strokeColor: string) => {
    return [avatarBg1(fillColor, strokeColor), avatarBg2(fillColor, strokeColor)]
}

const SpriteList: React.FC<SpriteListProps> = ({ selectSpriteElement, activeSpriteId }) => {
    let world = (window as any).world as FlatWorld;
    let spriteElements: JSX.Element[] = [];

    const backgroundsArrayActive = avatarBackgrounds('#FFEDB8', '#E2AE4B')
    const backgroundsArrayInactive = avatarBackgrounds('#none', '#E1B633')

    let counter = 0;
    world.sprites.forEach((sprite) => {
        let index = sprite.costumes.findIndex((c) => c.id === sprite.costumeId);
        const background = sprite.name === activeSpriteId ? backgroundsArrayActive[counter % backgroundsArrayActive.length] || '' : backgroundsArrayInactive[counter % backgroundsArrayInactive.length] || ''
        if (sprite.costumes[index] === undefined) {
            return;
        }
        counter++;
        if (LevelManager.isBuildMode() || sprite.programmable) {
            spriteElements.push(
                <MenuItem
                    style={{
                        minWidth: "80px",
                        minHeight: "80px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundImage: `url('data:image/svg+xml;charset=utf8,${encodeURIComponent(background)}')`,
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center',
                        backgroundSize: 'contain',
                        transition: 'filter 0.3s ease, transform 0.3s ease',
                        flex: '1 1 auto',
                        margin: '5px',
                    }}
                    key={`spriteEditorDropdown-${sprite.id}-${sprite.costumeId}`}
                    onClick={() => selectSpriteElement(sprite)}>

                    <Avatar variant="square" alt={sprite.name.charAt(0)} src={sprite.costumes[index].image.src} style={{ minWidth: "110px", minHeight: "110px" }} imgProps={{ style: { objectFit: "contain" } }} />
                </MenuItem>
            );
        }
    });

    return (
        <div style={{ display: "flex", width: "96%", padding: "10px", maxHeight: "400px", overflowX: "auto",
            
         }}>
            <div style={{
                display: "flex",
                flexDirection: "row",
                flexWrap: "nowrap",
                flexGrow: "1",
                justifyContent: 'center',
            }}>
                {spriteElements}
            </div>
        </div>
    );
};

export default SpriteList;